import { User, ExternalSupervisorInvitation } from '../store/types';
import { SuSyApi } from './susyApi';
import { toast } from 'react-toastify';
import { INITIAL_USER_STATE } from '../utils';

export const getAllSupervisors = async (): Promise<Array<User>> => {
    const { data } = await SuSyApi.get(`/user/supervisors/all`);
    return data;
};

export const externalSupervisorSignUp = async (
    user: User,
    invitationId: string,
    file?: File | null
): Promise<User> => {
    if (!invitationId) {
        toast.error('Missing invitation id');
        return INITIAL_USER_STATE;
    }

    const formData = new FormData();
    if (file) {
        formData.append(`externalSupervisorSignUp_fileOfProof[]`, file);
    }
    formData.append('user', JSON.stringify(user));
    const { data } = await SuSyApi.post(
        `/user/${invitationId}/supervisorSignUp`,
        formData
    );

    return data;
};

export const getInvitationById = async (
    invitationId: string
): Promise<ExternalSupervisorInvitation> => {
    const { data } = await SuSyApi.get(`/invitation/${invitationId}`);
    return data;
};
